export default __webpack_public_path__ + "images/0x16c22105301cfd85fd0f911920d282d18cc175c1.png";